/* src/app/progress-spinner/progress-spinner.component.scss */
:host {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  z-index: 99999;
  padding: 16px;
  box-sizing: border-box;
}
.training-container {
  width: 100%;
  max-width: 500px;
}
.training-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.training-container .training-card {
  width: 100%;
  max-width: 420px;
  padding: 30px 24px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.3s ease;
}
.training-container .training-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
}
.training-container .training-card .loader-area {
  position: relative;
  margin-bottom: 20px;
}
.training-container .training-card .loader-area .spinner {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border-radius: 50%;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #6366f1;
  animation: spin 1s linear infinite;
}
.training-container .training-card .loader-area .ai-gif {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.training-container .training-card .title {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 40px;
}
.training-container .training-card .subtitle {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 20px;
}
.training-container .training-card .progress-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.training-container .training-card .progress-dots span {
  width: 8px;
  height: 8px;
  background: #6366f1;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}
.training-container .training-card .progress-dots span:nth-child(1) {
  animation-delay: -0.32s;
}
.training-container .training-card .progress-dots span:nth-child(2) {
  animation-delay: -0.16s;
}
.training-container .training-card .progress-dots span:nth-child(3) {
  animation-delay: 0s;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
@media (max-width: 480px) {
  .training-container {
    padding: 12px;
  }
  .training-container .training-card {
    padding: 24px 16px;
    border-radius: 16px;
  }
  .training-container .training-card .title {
    font-size: 18px;
  }
  .training-container .training-card .subtitle {
    font-size: 13px;
  }
  .training-container .training-card .loader-area .spinner {
    width: 60px;
    height: 60px;
  }
  .training-container .training-card .loader-area .ai-gif {
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 481px) and (max-width: 768px) {
  .training-card {
    max-width: 480px;
  }
  .training-card .title {
    font-size: 20px;
  }
}
/*# sourceMappingURL=progress-spinner.component.css.map */
